import React from 'react';
import { ThemeKey, THEMES } from '../../types/ThemeTypes';
import './PlaylistDetails.css';

interface ThemeSelectorProps {
    selectedTheme: ThemeKey;
    onThemeChange: (theme: ThemeKey) => void;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({ selectedTheme, onThemeChange }) => {
    return (
        <div className="theme-selector">
            <h4>choose a theme</h4>
            <div className="theme-buttons">
                {Object.entries(THEMES).map(([key, theme]) => (
                    <button
                        key={key}
                        className={`theme-button ${selectedTheme === key ? 'selected' : ''}`}
                        onClick={() => onThemeChange(key as ThemeKey)}
                        style={{ backgroundColor: theme.color }}
                    >
                        <img src={theme.image} alt={theme.name} />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ThemeSelector; 